import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import IconButton from '@mui/material/IconButton'

export const TopBarButton = styled(Button)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'inherit',
    textDecoration: 'none',
    padding: theme.spacing(2, 4),
    borderRadius: '40px',
    transition: 'background-color 0.3s linear',
    textTransform: 'uppercase',
    columnGap: theme.spacing(2),
    '&:hover': {
        backgroundColor: theme.palette.primary.light,
        boxShadow:
            '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)',
        color: 'white',
    },
}))

export const TopBarIconButton = styled(IconButton)(({ theme }) => ({
    color: 'inherit',
    padding: theme.spacing(2.5),
    borderRadius: '40px',
    textDecoration: 'none',
    transition: 'background-color 0.3s linear',
    '&:hover': {
        backgroundColor: theme.palette.primary.light,
        boxShadow:
            '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)',
        color: 'white',
        '& svg path': {
            fill: 'white',
        },
    },
}))
